import { render, staticRenderFns } from "./deleteProductStock.vue?vue&type=template&id=76a5baa6"
import script from "./deleteProductStock.vue?vue&type=script&lang=js"
export * from "./deleteProductStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports